import { Plugins } from '@capacitor/core';
import axios from 'axios'

const { Device } = Plugins;

export default {
  async sendEvent({ eventCategory, eventAction, eventLabel, eventValue }) {
    return axios.get(`https://www.google-analytics.com/collect`, {
      params: {
        v: 1,
        tid: 'UA-157539818-1',
        cid: (await Device.getInfo()).uuid,
        t: 'event',
        ec: `${eventLabel}/${eventCategory}`,
        ea: eventAction,
        el: eventLabel,
        ev: eventValue
      }
    })
  },
  async sendPageView({ path }) {
    return axios.get(`https://www.google-analytics.com/collect`, {
      params: {
        v: 1,
        tid: 'UA-157539818-1',
        cid: (await Device.getInfo()).uuid,
        t: 'pageview',
        dp: path
      }
    })
  },
}
